// Radio

.radioWrapper {
  [data-input] {
    position: relative;
  }

  .icon {
    position: absolute;
    pointer-events: none;
    opacity: 0;
    transition:
      color 200ms,
      opacity 200ms;
  }

  .icon:has(+ :checked) {
    opacity: 1;
  }

  input {
    opacity: 0;
  }

  label {
    font-size: var(--fs-14);
  }
}

.icon {
  width: var(--space-5);
  height: var(--space-5);
}

// Text Input

.inputWrapper {
  label {
    font-size: var(--fs-14);
  }

  span {
    color: var(--color-text-tertiary);
    font-size: var(--fs-12);
    line-height: var(--fs-16);
  }
}

input.input {
  font-size: var(--fs-16);
  background: none;
  border-radius: var(--space-2);
  border: 0.5px solid var(--color-text-tertiary);
  padding: var(--space-2);
  transition:
    background 200ms,
    border 200ms,
    opacity 200ms;

  &:hover:not(:disabled) {
    box-shadow: 0 1px var(--space-1) 0
      rgb(from var(--color-text-primary) r g b / 10%);
    background: var(--color-bg-highlight);
  }

  &:focus {
    outline: 2px solid var(--color-border-brand);
  }

  &:disabled {
    border-color: var(--color-bg-disabled);
    opacity: 0.5;
  }
}

.inputIcon {
  svg {
    width: 20px;
    height: 20px;
    inset-inline-start: var(--space-2);
    inset-block-start: var(--space-2);
  }
}

// Toggles

.toggle > span {
  background: var(--color-text-tertiary);

  &::before {
    box-shadow: none;
    background: var(--color-bg-primary);
  }
}

.toggle.toggleSmall {
  --padding: 2px;
  --diameter: 14px;

  > span {
    width: 32px;
  }

  > input:checked + span::before {
    transform: translateX(var(--diameter));
  }
}
